import type { Locale } from '@/settings/langs'
import { getLocalePath } from '@/router/langRouteBuilder'
import { getVueRouter } from '@/router/routerInstance'
import { defaultLocale } from '@/settings/langs'

const LOCALE_KEY = 'preferred-locale'

function getCurrentLocale(): string {
  const route = getVueRouter()?.currentRoute?.value
  return String(route?.meta?.pageData?.locale || route?.params?.locale || defaultLocale)
}

function getRouteParams(): Record<string, string> {
  const params = getVueRouter()?.currentRoute?.value?.params ?? {}
  return Object.fromEntries(
    Object.entries(params).map(([k, v]) => [k, Array.isArray(v) ? (v[0] ?? '') : v])
  )
}

function getRouterGroup(): string {
  return String(getVueRouter()?.currentRoute?.value?.meta?.pageData?.routerGroup ?? '')
}

export function switchLocale(targetLocale: Locale): void {
  if (targetLocale === getCurrentLocale())
    return
  const newPath = getLocalePath(getRouterGroup(), getRouteParams(), targetLocale)
  if (!newPath)
    return
  localStorage.setItem(LOCALE_KEY, targetLocale)
  window.location.href = newPath
}
